import React from 'react'
import { Query } from '@apollo/client/react/components'

import { GET_ORDER_NUMBER } from 'graphql/queries/order'
import { FormattedMessage } from 'react-intl'

const OrderBreadcrumb = ({
  match: {
    params: { id }
  }
}) => (
  <Query query={GET_ORDER_NUMBER} variables={{ id }}>
    {({ loading, error, data }) => {
      if (loading) {
        return (
          <FormattedMessage
            id='Common.loading'
            defaultMessage='Loading'
          />
        )
      }

      if (error) {
        return (
          <FormattedMessage
            id='Common.failed'
            defaultMessage='Something went wrong'
          />
        )
      }

      return <span>{data.order.orderNumber}</span>
    }}
  </Query>
)

export default OrderBreadcrumb



// WEBPACK FOOTER //
// ./src/components/Routes/components/OrderBreadcrumb/index.js